<template>
  <div class="page-content">
    <div class="container has-text-left">
      <div class="hero is-medium">
        <div class="hero-body" v-if="this.orderTrackingInfo.shippingInformation">

          <h1 class="title is-2 has-text-grey">{{ $t('checkout.quoteGenerated.headline') }}.</h1>

          <p class="title is-3 has-text-grey">
            <span v-if="orderShippingAddress.customerEmail.value" v-html="$t('checkout.quoteGenerated.emailSentTo', {email: orderShippingAddress.customerEmail.value})">
            </span>
            <span v-else>
              {{ $t('checkout.quoteGenerated.emailSent') }}
            </span>
          </p>

        </div>
      </div>
    </div>
    <div class="container">
      <div class="section">
        <a @click="goToStart()" class="is-size-3">{{ $t('actions.backToStart') }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import CartItemList from "./CartItemList";
import {orderProcess} from "../../store/constants/order-process";
import AddressSummary from "./ReviewOrder/AdressSummary";

export default {
  name: "QuoteGenerated",
  components: {AddressSummary, CartItemList},
  computed: {
    ...mapGetters(['orderTrackingInfo', 'paymentDetails']),
    orderDetails() {
      return {
        orderID: {
          label: this.$i18n.t("orderDetails.labels.orderNumber"),
          value: this.orderTrackingInfo.orderNumber
        },
        orderDate: {
          label: this.$i18n.t("orderDetails.labels.createdAt"),
          value: this.$i18n.d(new Date(this.orderTrackingInfo.createdAt))
        },
        orderState: {
          label: this.$i18n.t("orderDetails.labels.orderStatus"),
          value: this.$i18n.t(`checkout.orderStatusLabels.${this.orderTrackingInfo.orderStatus}`)
        },
        productionTime: {
          label: this.$i18n.t("orderDetails.labels.productionTime"),
          value: this.$i18n.tc('checkout.productionTimeDays', this.orderTrackingInfo.estimatedProductionTimeDays)
        },
        shippingTime: {
          label: "+" + this.$i18n.t("orderDetails.labels.deliveryTimeShort"),
          value: this.$i18n.tc('checkout.productionTimeDays', this.orderTrackingInfo.shippingMethod.shippingTimeDays)
        }
      }
    },
    orderShippingAddress() {
      return {
        customerName: {
          label: this.$i18n.t("orderDetails.labels.name"),
          value: `${this.orderTrackingInfo.shippingInformation.firstname} ${this.orderTrackingInfo.shippingInformation.lastname}`
        },
        customerEmail: {
          label: this.$i18n.t("orderDetails.labels.email"),
          value: this.orderTrackingInfo.email
        },
        customerStreet: {
          label: this.$i18n.t("orderDetails.labels.address"),
          value: `${this.orderTrackingInfo.shippingInformation.street}`
        },
        customerZipAndCity: {
          label: this.$i18n.t("orderDetails.labels.city"),
          value: `${this.orderTrackingInfo.shippingInformation.postalCode} ${this.orderTrackingInfo.shippingInformation.city}`
        },
        customerCountry: {
          label: this.$i18n.t("orderDetails.labels.country"),
          value: `${this.orderTrackingInfo.shippingInformation.country.name}`
        }
      }
    },
  },
  methods: {
    goToStart() {
      this.$router.push('/');
    },
    fetchCMSData() {
      this.$store.dispatch('fetchCMSPage', {urlSlug: "/"});
    },
  },
  created() {
    let cookieConsent = localStorage.getItem('cookies');
    let mrSessionId = localStorage.getItem('mrSessionId');
    localStorage.clear();
    localStorage.setItem('cookies', cookieConsent);
    localStorage.setItem('mrSessionId', mrSessionId);
    this.fetchCMSData();
    this.$store.dispatch('setCurrentOrderProcessStep', orderProcess.STEPS.ORDER_COMPLETED);
    this.$store.dispatch('clearCart');
    this.$store.dispatch("createCart");
    this.$store.dispatch('fetchOrderTrackingInfo', {
      path: "/rest_api/trackorder.php",
      params: this.$route.query
    })
  }
}
</script>

<style scoped>

</style>